import React from "react";
import { CalendarHeart, Sparkles } from "lucide-react";
import { Reveal } from "../Reveal";
import { CONTACT } from "../../config";

export function Events() {
  const wa = `${CONTACT.whatsappBase}?text=${encodeURIComponent("Hi! I'd like to know about upcoming events and Fun Fridays at DMediaClub.")}`;
  return (
    <section id="events" className="bg-butter py-20 md:py-28" style={{ background: "#FBE08A" }}>
      <div className="max-w-[1320px] mx-auto px-5 md:px-8">
        <Reveal><span className="sticker bg-cream"><Sparkles size={15} strokeWidth={2} /> Upcoming events</span></Reveal>
        <Reveal delay={0.05}>
          <h2 className="display text-berry text-4xl sm:text-5xl md:text-6xl mt-6 max-w-2xl">Come create with the community.</h2>
        </Reveal>
        <div className="mt-12 grid md:grid-cols-2 gap-6 items-stretch">
          <Reveal y={24}>
            <div className="card-soft bg-blush p-8 h-full relative" style={{ background: "#F7C9DC" }}>
              <span className="sticker absolute -top-4 right-6 bg-cream rotate-3">Fun Fridays</span>
              <CalendarHeart size={34} strokeWidth={1.8} className="text-berry" />
              <h3 className="font-serif text-2xl text-charcoal mt-4">Fun Fridays at DMediaClub</h3>
              <p className="mt-3 text-charcoal/80">
                A recurring community gathering for Orlando creatives. Dates, themes, and tickets are
                announced regularly — reach out and we’ll share what’s coming up next.
              </p>
              <a href={wa} target="_blank" rel="noreferrer" className="btn inline-flex mt-6 bg-berry text-cream border-2 border-berry px-6 py-3 shadow-[3px_3px_0_#2A1020]">
                Ask about upcoming dates
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.08} y={24}>
            <div className="card-soft bg-cream p-8 h-full">
              <h3 className="font-serif text-2xl text-charcoal">Hosting your own event?</h3>
              <p className="mt-3 text-charcoal/80">
                DMediaClub is a great home for workshops, masterclasses, and curated brand experiences.
                Tell us your idea and we’ll help you find a date.
              </p>
              <p className="mt-4 text-sm text-charcoal/60">
                Have a specific event, date, or ticket link you’d like featured here? Send it over and we’ll add it.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
